import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { AgreementsAutocomplete } from "@shared/components/AutocompleteFields";

export function PromocodeForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>

      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={translate("promocode_admin.fields.agreement")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="code"
          label={translate("promocode_admin.fields.code")}
          required
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="max_usage"
          label={translate("promocode_admin.fields.max_usage")}
          mask="number"
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="valid_for"
          label={translate("promocode_admin.fields.valid_for")}
          mask="number"
          instructions={translate("promocode_admin.instructions.valid_for_months")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.DatePicker
          name="valid_until"
          label={translate("promocode_admin.fields.valid_until")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="active"
          label={translate("promocode_admin.fields.active")}
        />
      </Grid>
    </Grid>
  );
}
